import { CreateTemplatePage } from '../[[...slug]]'

const { Page, ...rest } = CreateTemplatePage('is')

export default Page
export const getStaticProps = rest.getStaticProps
export const getStaticPaths = rest.getStaticPaths
